import React from "react";
import Sidebaar from "../Component/Sidebaar";
import UserList from "../Element/UserList";

function UserlistPage() {
  return <Sidebaar content={<UserList />} />;
}

export default UserlistPage;
